import get from '../helpers/get';
import omit from '../helpers/omit';
import { getSliceContent, getSliceItems } from './content';
import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import { isCurrentBreakpointMobile } from './layout';
import {
  resolveAlignmentSetting,
  resolveIsDarkSetting,
  resolvePositionSetting,
} from './settings';

export const getCarouselSlideIndex = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'slideIndex'],
) || 0;
export const getCarouselSlideDuration = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'slideDuration'],
) || 6000;
export const isCarouselPaused = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'paused'],
) || false;
export const isCarouselVideoPlaying = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'videoPlaying'],
) || false;
export const getCarouselVideoDuration = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'videoDuration'],
) || 0;
export const getCarouselVideoCurrentTime = (state, carouselSliceId) => get(
  state.carousel,
  [carouselSliceId, 'videoCurrentTime'],
) || 0;
export const getCarouselVideoProgress = createPerSliceIdSelector(
  getCarouselVideoDuration,
  getCarouselVideoCurrentTime,
  (duration, currentTime) => {
    if (duration) {
      return currentTime / duration;
    }
    return 0;
  },
);
export const getCarouselSlideCount = createPerSliceIdSelector(
  getSliceContent,
  sliceContent => get(sliceContent, ['items', 'length']) || 0,
);

export const getCarouselSlides = createPerSliceIdSelector(
  getSliceItems,
  isCurrentBreakpointMobile,
  (items, isMobile) => items.map(({
    copy,
    copy_enabled: copyEnabled,
    hero_image: image,
    hero_video: video,
    overlay_vector_image: overlayImage,
    cta_type: ctaType,
    background_color: backgroundColor,
    cta,
    ...slide
  }) => ({
    ...omit(slide, ['alignment_mobile', 'position_mobile', 'theme', 'theme_mobile']),
    image,
    video,
    title: get(slide, ['title', 'text']),
    copy: (isMobile && copyEnabled === 'Hidden on mobile') ? undefined : copy,
    overlayImage,
    cta: ctaType !== 'Whole Header' ? cta : undefined,
    ctaHeader: ctaType === 'Whole Header' ? cta : undefined,
    backgroundColor,
    alignment: resolveAlignmentSetting(slide),
    position: resolvePositionSetting(slide),
    isDark: resolveIsDarkSetting(slide),
  })),
);

export const getCarouselSlide = (state, sliceId, itemIndex) => get(
  getCarouselSlides(state, sliceId),
  [itemIndex],
);

export const getCarouselCurrentSlide = createPerSliceIdSelector(
  getCarouselSlides,
  getCarouselSlideIndex,
  (slides, slideIndex) => slides[slideIndex],
);

export const getCarouselCurrentSlideIsDark = createPerSliceIdSelector(
  getCarouselCurrentSlide,
  slide => get(slide, ['isDark']) || resolveIsDarkSetting({}),
);

export const getStrictAspects = (aspects, device) => aspects && aspects[device];
